module.exports = __webpack_public_path__ + "img/apple-ar-2x.13d6ffe6.png";